module.exports = __webpack_public_path__ + "img/3d8e680.png";